<template>
  <div id="app">
      <router-view></router-view>
      <Footer/>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0
    };
  },
  methods: {
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        if (res && res.code === 200 && res.data) {
          this.$store.commit('setBaseInfoValue', res.data);
        }
        if(!localStorage.getItem('token')){
           this.$router.push({path:'/Login'})
        }
      })
    }

  },
  created(){
    this.getBaseInfo();
  }
}
</script>

<style>
html, body, #app {
  background: var(--bg, #000) !important;
  color: var(--text-muted, #c8c8c8);
  min-height: 100%;
}
body .van-toast {
  font-size: 38px;
  padding: 30px;
  line-height: 50px;
  width: 500px;
  background: var(--gold, #c9a84c) !important;
  color: #000 !important;
}
body .van-toast .van-toast__icon {
  font-size: 50px;
  color: #000 !important;
}
*, :after, :before {
  box-sizing: border-box;
}
/* 全局顶栏黑金 */
.van-nav-bar {
  background: var(--bg, #000) !important;
  border-bottom: 1px solid var(--border-gold, rgba(201,168,76,0.45)) !important;
}
.van-nav-bar .van-nav-bar__title,
.van-nav-bar .van-icon {
  color: var(--gold, #c9a84c) !important;
}
.van-hairline--bottom::after {
  border-bottom-width: 0 !important;
}
.van-button--primary {
  background: var(--gold, #c9a84c) !important;
  border-color: var(--gold, #c9a84c) !important;
  color: #000 !important;
}
.van-cell,
.van-cell-group,
.van-field {
  background: var(--surface, #141414) !important;
  color: var(--gold, #c9a84c) !important;
}
.van-field__label,
.van-cell__title {
  color: var(--gold, #c9a84c) !important;
}
.van-field__control {
  color: var(--text-muted, #c8c8c8) !important;
}
.van-field__control::placeholder {
  color: var(--gold-soft, #8a7a55) !important;
}
.van-empty__description {
  color: var(--text-muted, #c8c8c8) !important;
}
</style>
